import KFStandard from "../../KFDetail/KFStandard/KFStandard.vue";
import KostenMixin from "../Mixins/KostenMixin";
import {
  cloneDeep,
  get,
} from "lodash-es";

// @vue/component
export default {
  name: "KostenMitPauschale",
  components: {
    KFStandard,
  },
  mixins: [
    KostenMixin,
  ],
  data() {
    return {
      editType: "single-position",
    };
  },
  computed: {
    sumLocal() {
      return this.summeCurrency;
    },

    extraForVorschau() {
      return {
        tagespauschale: this.modelParameter.pauschale,
      };
    },
  },
  methods: {
    prepareModel_KFBaseMixin({ model }) {
      const MODEL = cloneDeep(model);
      const TAGESPAUSCHALE = get(MODEL, "argument.tagespauschale");
      if (!TAGESPAUSCHALE) {
        MODEL.argument = MODEL.argument || {};
        MODEL.argument.tagespauschale = this.modelParameter.pauschale;
      }
      return MODEL;
    },
  },
};
